import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientHistory(id: string | undefined) {
  return useQuery(queries.patients.getPatientHistory(id || ''))
}
